import { render } from "./ContadorComponent.vue?vue&type=template&id=69d3df31&ts=true"
import script from "./ContadorComponent.vue?vue&type=script&lang=ts"
export * from "./ContadorComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__